module.exports = __webpack_public_path__ + "img/articulos3.a6ee5e49.png";